
import BCXQuickLayer from '@/components/molecules/BCXQuickLayer.vue';
import X from '@/components/svg-components/X.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import useQuickInfo from '@/state/quickInfo';
import ProfileQuickInfo from '@/views/profile/ProfileQuickInfo.vue';
import { computed, defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'QuickInfoLayer',
  components: {
    BCXQuickLayer,
    X,
    ProfileQuickInfo
  },
  setup() {
    const {
      quickInfoUser, closeQuickInfo, target, quickInfoX, quickInfoY, showMore
    } = useQuickInfo();
    const { isMobileWidth, isSmartphoneWidth } = useResponsiveness();

    const isClosing = ref(false);

    const close = () => {
      isClosing.value = true;
    };
    const onHasDisappeared = () => {
      closeQuickInfo();
      isClosing.value = false;
    };

    const isOpen = computed(() => !!(quickInfoUser.value && !isClosing.value));

    return {
      quickInfoUser,
      close,
      onHasDisappeared,
      isMobileWidth,
      showMore,
      isOpen,
      target,
      quickInfoX,
      quickInfoY,
      isSmartphoneWidth
    };
  }
});
